import { computed, type ComputedRef } from 'vue';
import { useColorMode, usePreferredDark } from '@vueuse/core';

/**
 * Reactive flag telling whether dark mode is currently active.
 *
 * Tracks the same `useColorMode` state the admin layout drives (which toggles the
 * `.dark` class on <html>), resolving `auto` against the system preference.
 *
 * @returns ComputedRef<boolean> True when dark mode is active.
 */
export function useIsDark(): ComputedRef<boolean> {
    const mode = useColorMode({ emitAuto: true });
    const prefersDark = usePreferredDark();

    return computed(() => mode.value === 'dark' || (mode.value === 'auto' && prefersDark.value));
}
